import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";
import { MobileNav } from "./MobileNav";
import { IdleTimeoutWarning } from "@/components/patria/IdleTimeoutWarning";

export function AppShell() {
  return (
    <div className="min-h-screen bg-sage-200">
      <Header />
      <div className="flex">
        <Sidebar />
        <main className="flex-1 min-w-0 pb-24 lg:pb-8">
          <div className="max-w-6xl mx-auto p-4 sm:p-6 lg:p-10 animate-fade-up">
            <Outlet />
          </div>
        </main>
      </div>
      <MobileNav />
      <IdleTimeoutWarning />
    </div>
  );
}
